import { FC, useCallback, useMemo } from 'react'

import { RowButtons } from 'partner360/components/rowButtons/RowButtons'

import { CONTENT_TYPE_OPTIONS } from './configs'
import { GlobalPartnerContentTypes, IContentTypeButtonsProps } from './models'

import styles from './ContentTypeButtons.module.scss'

export const ContentTypeButtons: FC<IContentTypeButtonsProps> = ({
  value,
  translationKeyPrefix,
  onContentTypeChange,
  isNewGlobalPartner,
}) => {
  const generateTranslationKey = useCallback(
    (option: GlobalPartnerContentTypes) => {
      return `${translationKeyPrefix}--${option.toLowerCase()}-button`
    },
    [translationKeyPrefix]
  )

  const visibleOptions = useMemo(() => {
    if (isNewGlobalPartner) {
      return [GlobalPartnerContentTypes.BasicInfo]
    }
    return CONTENT_TYPE_OPTIONS
  }, [isNewGlobalPartner])

  return (
    <RowButtons
      value={value}
      options={visibleOptions}
      generateTranslationKey={generateTranslationKey}
      onOptionClick={onContentTypeChange}
      buttonClassName={styles.button}
    />
  )
}
